import {
  WSMenuItem,
  WSTable,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import { useFileDownload } from "../hooks/useFileDownload";
import { FileNameCell } from "./FileNameCell";

type FileData = {
  fileId: string;
};

type Props = {
  fileIds: string[];
  onRemove?: (fileId: string) => void;
};

export const FilesTable: React.FC<Props> = ({ fileIds, onRemove }) => {
  const { download } = useFileDownload();

  const tableData = useMemo(
    () => fileIds.map(fileId => ({ id: fileId, data: { fileId } })),
    [fileIds]
  );

  const columns: WSTableColumn<FileData>[] = useMemo(
    () => [
      { renderFunction: item => <FileNameCell fileId={item.data.fileId} /> }
    ],
    []
  );

  const rowMenuActions = useMemo(
    () =>
      ({ data }: { data: FileData }): WSMenuItem[] => {
        const items: WSMenuItem[] = [
          {
            label: "Download",
            icon: "download",
            onClick: () => download(data.fileId)
          }
        ];
        if (onRemove) {
          items.push(
            { separator: true },
            {
              label: "Remove",
              icon: "trash",
              onClick: () => onRemove(data.fileId),
              iconProps: { color: "red400" },
              labelProps: { color: "red400" }
            }
          );
        }
        return items;
      },
    [download, onRemove]
  );

  return (
    <WSTable<FileData>
      showHeader={false}
      tableData={tableData}
      columns={columns}
      rowActions={({ data }) => {
        return [
          {
            text: "",
            onlyIcon: true,
            icon: "download",
            onClick: () => download(data.fileId)
          }
        ];
      }}
      rowMenuActions={rowMenuActions}
    />
  );
};
